// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueQrcode from '@xkeshi/vue-qrcode'
import ElUpload from 'element-upload'
import VeeValidate from 'vee-validate'
import VueMask from 'v-mask'
import VueI18n from 'vue-i18n'
import messages from './lang'
import VueCookie from 'vue-cookie'
import Store from './store'
import VueAnalytics from 'vue-analytics'
import VueClipboard from 'vue-clipboard2'

Vue.use(VeeValidate)
Vue.use(VueResource)
Vue.config.productionTip = false
Vue.component('qrcode', VueQrcode)
Vue.component('el-upload', ElUpload)
Vue.use(VueMask)
Vue.use(VueI18n)
Vue.use(VueCookie)
Vue.use(VueClipboard)
Vue.use(VueAnalytics, {
  id: 'UA-33483801-1',
  router
})

Vue.http.options.emulateJSON = false
/* eslint-disable no-new */
Vue.http.interceptors.push(function (request, next) {
  request.credentials = true
  next(function (response) {
    if (response.status === 401 && router.app.$route.path !== '/login' && router.app.$route.path !== '/fb-login') {
      router.push('login')
    } else if (response.headers.get('x-friends-location')) {
      window.location = response.headers.get('x-friends-location')
    }
  })
})

const i18n = new VueI18n({
  // locale: 'ua',
  messages
})

new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App },
  created: function () {
    var uLang = this.$cookie.get('uLang')
    if (uLang) {
      this.$i18n.locale = uLang
    } else {
      this.$i18n.locale = 'ua'
    }
    Store.commit('setLang', uLang)
    document.title = this.$t('commons.title')
  }
})




// WEBPACK FOOTER //
// ./src/main.js